/**
 * Shared styling constants for Chat V2 layout.
 * Used by both ChatInputV2 and Message components.
 */

export const CHAT_V2_LAYOUT = {
  /** Maximum width for chat content (messages, input) */
  maxWidthClass: 'max-w-[740px]',

  /** Human message container styles */
  humanMessage: {
    width: 'w-fit min-w-[40%] max-w-[85%]',
    padding: 'pl-16 pt-8 pr-4',
  },
} as const;
